import { LoadingOverlay } from '@mantine/core'

interface LoaderProps {
  visible: boolean
}

function Loader({ visible }: LoaderProps) {
  // zindex set to 199 to set smaller than sidebar drawer
  return <LoadingOverlay visible={visible} zIndex={199} loaderProps={{ color: '#001E61' }} />
}

export default Loader
